import { DropdownWrap } from "@Elements/Form/DropdownWrap";
import * as React from "react";
import { useIntl } from "react-intl";
import { powerFailureReportOpts } from "./options";
import { TIME_OFFSET, status } from "@Elements/Form/utils";
import { SettingHeader, TitleWrap } from "@Elements/Form/styles";
import { BatteryThreshold } from "../battery";
import { Section, FieldGrid } from "./settingsLayout";

export const PowerFailureReport = 
  DropdownWrap(
    "powerFailureReportDelay", 
    {
      title: {id: "batteryAndPowerPowerParagraphTitle", defaultMessage: "Strømbruddsforsinkelse"},
      tooltip: "batteryAndPowerPowerToolTipText",
      tooltipTitle: {id: "batteryAndPowerPowerToolTipTitle", defaultMessage: "Strømbruddsforsinkelse"},
      dataOptions: {
        options: powerFailureReportOpts,
        offset: TIME_OFFSET.SECONDS_IN_SECOND,
        nullValue: status.disable
      },
      width: "100%"
    }
  );

const ThresholdField = () => {
  const { formatMessage } = useIntl();
  return(
    <div>
      <SettingHeader>
        <TitleWrap right>
          {formatMessage({id: "batteryTreshold", defaultMessage: "Batteriterskel"})}
        </TitleWrap>
      </SettingHeader>
      <BatteryThreshold/>
    </div>
  )
}

export const GX8BatterySection = () => {
  return(
    <Section>
      <FieldGrid>
        <ThresholdField/>
        <PowerFailureReport/>
      </FieldGrid>
    </Section>
  )
}

export const GX8BatterySectionSTCB = () => {
  return(
    <Section>
      <FieldGrid>
        <ThresholdField/>
      </FieldGrid>
    </Section>
  )
}